<template>
  <div>

    <div class="pfd__tag" :style="{ 'color': ActiveColor }">{{ pfdTag }}</div>

    <h1 class="pfd__title heading--style" v-html="pfdTitle" />

    <div class="pfd__desc rich-text" v-html="pfdDescription" />
    <div class="ratingSection">
      <a href="#" @click.prevent="reviewTag" :class="isBazaarvoiceActivated === true ? '' : 'star-rating__caption'">
        <div v-if="isBazaarvoiceActivated === true">
          <div data-bv-show="rating_summary" :data-bv-product-id="productId"></div>
        </div>
        <div v-else class="pfd__star-rating star-rating">
          <star-rating :increment="1" :max-rating="5" :inactive-color="InactiveColor" :active-color="ActiveColor"
            :border-color="ActiveColor" :border-width="1" :star-size="28" :rating="overallRating" :read-only="true"
            :show-rating="false" aria-hidden="true" />
          <span class="pfd__star-rating--count">{{ StarRatingCount }}/5</span>
          <span class="pfd__star-rating--total">{{ StarRatingText }}</span>
        </div>
      </a>
    </div>

  </div>


</template>

<script>

import StarRating from 'vue-star-rating';

export default {
  name: 'product-description-head',
  components: {

    StarRating,
  },
  props: {

    pfdTag: { type: String, required: false, default: '' },
    pfdTitle: { type: String, required: false, default: '' },
    pfdDescription: { type: String, required: false, default: '' },
    StarRatingText: { type: String, required: false, default: '' },
    StarRatingCount: { type: String, required: false, default: '' },
    InactiveColor: { type: String, required: true, default: '' },
    ActiveColor: { type: String, required: true, default: '' },
    AverageRating: { type: Number, required: true, default: 4 },
    productIds: { type: Array, required: false, default: [] },
    productId: { type: String, required: false, default: '' },
    isBazaarvoiceActivated: { type: Boolean, required: false, },
    hoverColor: { type: String, required: false, default: '' },

  },

  data() {
    return {
      overallRating: this.AverageRating,

    };
  },

  created() {
    document.documentElement.style.setProperty('--hover-color', this.hoverColor);
    document.documentElement.style.setProperty('--active-color', this.ActiveColor);
  },

  destroyed() {
    document.documentElement.style.removeProperty('--hover-color');
    document.documentElement.style.removeProperty('--active-color');
  },

  methods: {
  reviewTag() {
      let url = window.location.href;
      let res = url.split("#");
      let hash = res[1];
      if(!hash) {
        window.location = url+'#ratings';
      }else{
        window.location = url;
      }
    },
  },
};
</script>

<style lang="scss" src="./product-description.scss"></style>
